module.exports = __webpack_public_path__ + "components/flag/static/square/mk-646de9620cbb0490da8fd119245ed28f.svg";